import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// As escalas semânticas de texto do tema precisam ser conhecidas pelo tailwind-merge,
// senão `text-body` seria tratado como cor e conflitaria com `text-ink`. O mesmo vale para os
// espaços nomeados (`min-h-touch`, `h-header`): sem isso, `min-h-0` não substituiria `min-h-touch`.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: ['header', 'nav-item', 'touch', 'touch-desk'],
    },
    classGroups: {
      'font-size': [{ text: ['eyebrow', 'body', 'lead', 'name', 'block', 'page', 'hero'] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
